const TOKEN_KEY = 'sofio_access_token';
const REFRESH_TOKEN_KEY = 'sofio_refresh_token';
const TOKEN_EXPIRY_KEY = 'sofio_token_expiry';
const REFRESH_TOKEN_EXPIRY_KEY = 'sofio_refresh_token_expiry';
const USER_INFO_KEY = 'sofio_user_info';

export function saveTokens(tokens: AuthAPI.Tokens): void {
  localStorage.setItem(TOKEN_KEY, tokens.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  localStorage.setItem(TOKEN_EXPIRY_KEY, tokens.accessTokenExpiry);
  localStorage.setItem(REFRESH_TOKEN_EXPIRY_KEY, tokens.refreshTokenExpiry);
}

export function getAccessToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getTokenExpiry(): Date | null {
  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
  return expiry ? new Date(expiry) : null;
}

export function isTokenExpired(): boolean {
  const expiry = getTokenExpiry();
  if (!expiry) return true;
  return new Date().getTime() > expiry.getTime() - 60 * 1000;
}

export function isRefreshTokenExpired(): boolean {
  const expiry = localStorage.getItem(REFRESH_TOKEN_EXPIRY_KEY);
  if (!expiry) return true;
  return new Date().getTime() > new Date(expiry).getTime();
}

export function clearTokens(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
  localStorage.removeItem(REFRESH_TOKEN_EXPIRY_KEY);
  localStorage.removeItem(USER_INFO_KEY);
}

export function saveUserInfo(user: AuthAPI.UserInfo): void {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(user));
}

export function getUserInfo(): AuthAPI.UserInfo | null {
  const user = localStorage.getItem(USER_INFO_KEY);
  return user ? JSON.parse(user) : null;
}

export function updateAccessToken(accessToken: string, accessTokenExpiry: string): void {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(TOKEN_EXPIRY_KEY, accessTokenExpiry);
}

export function isLoggedIn(): boolean {
  const token = getAccessToken();
  const refreshToken = getRefreshToken();
  return !!(token && refreshToken && !isRefreshTokenExpired());
}
